// extracted by mini-css-extract-plugin
module.exports = {"b1y26brn":"b1y26brn"};